// CustomerRow.jsx
import React, { useState } from 'react';
import Classes from './Orders.module.css';

import MoreDropDown from './MoreDropDown';
import DropDown from './StatusDropDown/DropDown';

export default function TableRow({ value, index }) {

  return (
    <>
      {/* Desktop view */}
      <div
        className={`${Classes.customerRow} ${value.status === 'disabled' ? Classes.disabledRow : ''
          }`}
        key={value.ID}
      >
        {/* Name/Email */}
        <div className={`${Classes.customerInfo} ${Classes.colCustomer}`}>
          <h5 className="truncate">{value.ID}</h5>
        </div>
        {/* Spend */}
        <div className={`${Classes.spendings} ${Classes.colSpendings}`}>
          <h5>{value.Title}</h5>
        </div>
        {/* Bookings */}
        <div className={`${Classes.bookings} ${Classes.colBookings}`}>
          <h5>{value.Created}</h5>
        </div>
        {/* Date Joined */}
        <div className={`${Classes.dateJoined} ${Classes.colDate}`}>
          <h5>{value.Amount}</h5>
        </div>
        {/* Disable toggle */}
        <div className={`${Classes.disableToggle} ${Classes.colDisable}`}>
          <DropDown
            selectedValue={value.Status}
            options={["Pending", "Submitted", "Working", "Completed", "Canceled"]}
            onChange={(val) => value.Status = val}
            isDropDown={false}
          />
        </div>
        {/* Actions */}
        <div className={`${Classes.actions} ${Classes.colActions}`}>
          <MoreDropDown
            index={index}
            user={value}
          />
        </div>
      </div>
    </>
  );
}
